const MellonWebECRIntentResult = Object.freeze({
    APPROVED: 1,
    DECLINED: 2,
    CANCELLED: 3,
    FAILED: 4,
    UNKNOWN: 5,
    BUSY: 6,
    MAX_TRANSACTIONS: 7,
});

module.exports = MellonWebECRIntentResult;
